/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
/* eslint-disable no-await-in-loop */
import * as ActionTypes from '~/actions/ActionTypes'
import { activateProject } from '~/actions/projectData/activateProject'
import { startProjectLoading } from '~/actions/projectData/startProjectLoading'
import { rewind } from '~/actions/timeline'
import { newProjectId, newProjectName } from '~/constant'
import * as API from '~/ServerAPI'
import { clearEditor } from './clearEditor'
import { setActiveProjectError } from './setActiveProjectError'
import { getProject } from './mappings/getAssetMapping'
import { prepareProjectAssets } from '~/helpers/assets/prepareProjectAsset'

import { ERROR_TYPE } from '~/errors/ErrorType'
import { extractProjectIOPoints, extractDefaultProjectTransDuration } from '~/actions/preview'
import { extractProjectTimeCodeData } from '~/actions/playback'
import { endProjectLoading } from './endProjectLoading'
import { versionBackwardCompatibilityBefore } from './versionBackwardCompatibilityBefore'
import { clearProjectMedia, saveProjectFileIds } from './saveProject'
import { fetchNextProjectName } from './fetchNextProjectName'
import { adjustProjectReference } from './adjustProjectReference'


export const loadProject = projectId => async dispatch => {
  await dispatch(clearProjectMedia())

  await dispatch(clearEditor())
  await dispatch(startProjectLoading())
  if (projectId && projectId !== newProjectId) {
    try {
      const response = await API.getProject(projectId)
      const projectData = JSON.parse(response.data)
      const project = getProject(typeof response.data === 'string' ? projectData : response.data)
      const { userId, name } = response
      const { version,
        createTime: projectDataCreateTime } = projectData
      // http://18.184.210.86/issues/2095
      const actualCreateTime = projectDataCreateTime || response.createTime
      await dispatch(activateProject({
        id: projectId,
        name,
        userId,
        activeProject: { ...projectData, createTime: actualCreateTime },
      }))

      const { layers, timeline } = project
      const { scale, sliderTime, scrollLeft } = timeline

      // OLD VERSION BACKWARD COMPATIBILITY
      await versionBackwardCompatibilityBefore(project, version, projectId)

      const assets = layers
        .reduce((acc, l) => ([ ...acc, ...l.assets ]), [])
        .filter(a => a.duration)
      await prepareProjectAssets(assets)
      await dispatch({ type: ActionTypes.LOAD_PROJECT,
        payload: {
          layers,
          assets,
          scale,
          sliderTime,
          scrollLeft,
          isLoading: true,
        } })
      if (project.fileIds) {
        dispatch(saveProjectFileIds(project.fileIds))
      }
      await dispatch(adjustProjectReference(project))
      // This is useful for correct initialize preview players
      await dispatch(rewind(project.timeline.sliderTime))
    } catch (e) {
      console.error(e)
      dispatch(setActiveProjectError(ERROR_TYPE.PROJECT_LOAD_FAILED, `Cannot load project: ${e.message || e}`))
    }
  } else {
    const nextProjectName = await dispatch(fetchNextProjectName(newProjectName))
    await dispatch(activateProject({ id: newProjectId, name: nextProjectName }))
  }
  await dispatch(extractProjectIOPoints())
  await dispatch(extractProjectTimeCodeData())
  await dispatch(extractDefaultProjectTransDuration())
  await dispatch(endProjectLoading())
}
